import { createSelector } from "reselect";
let sites = {
  1: "AmericanBlinds.com",
  2: "Blinds.ca",
  3: "Blinds.com",
  5: "JustBlinds.com",
  11: "TheHomeDepot"
};


/* const customLocalDateTime = apiDateTime => {
  let utcDateTime = apiDateTime + ".000Z";
let localDateTime = new Date(utcDateTime);
  let draftLocalDateTime = localDateTime.getMonth() + 1 + '/' + (localDateTime.getDate()) +
    '/' + localDateTime.getFullYear() + ' ' + localDateTime.toLocaleTimeString();

  return draftLocalDateTime;
}; */

export const vendorDraftProductListSelector = createSelector(
  state => state.vendorDraftProducts,
  vendorDraftProducts => {
    return vendorDraftProducts.map(draft => {
      draft = {
        ...draft,
        siteId:draft.website,
        website: Object.values(sites)[
          Object.keys(sites).findIndex(
            site => site === draft.website.toString()
          )
        ],
      };

      return draft;
    });
  }
);

// export const vendorDraftProductListSelector = createSelector(
//   vendorDraftProductsHelper,
//   draftProducts => {
//     return draftProducts.map(product => {
//       return Object.values(product)
//    });
//  },
// );
